import { render, staticRenderFns } from "./AddAddress.vue?vue&type=template&id=3f69a23e&scoped=true&"
import script from "./AddAddress.vue?vue&type=script&lang=js&"
export * from "./AddAddress.vue?vue&type=script&lang=js&"
import style0 from "./AddAddress.vue?vue&type=style&index=0&id=3f69a23e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f69a23e",
  null
  
)

export default component.exports